<script>
    export default {
        name: 'LazyFrame',
        data() {
            return {
                isClicked: false
            }
        },
        props: {
            embedCode: {
                type: String,
                default: ''
            }
        },
        methods: {
            doEmbed() {
                this.isClicked = true;
            }
        },
        computed: {
            embedHtml() {
                if (this.isClicked) {
                    return this.embedCode;
                } else {
                    return '';
                }
            }
        },
    };
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/LazyFrame.vue